module.exports = __webpack_public_path__ + "img/battery_1disable.6d427e60.png";